import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { DynamicsCrmEntityDataset } from 'app/model/dataset/dynamics-crm.dataset';
import { TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DynamicsCrmEntityDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            schema: '*',
            linkedServiceName: '*',
            parameters: '*',
            type: '*',
            typeProperties: {
                entityName: '*'
            }
        }
    }
})
export class DynamicsCrmEntityDatasetAdapter extends TabularTypeDatasetAdapter<DynamicsCrmEntityDataset, Model.DatasetResource> {
    protected async _toResource(dataset: DynamicsCrmEntityDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(DynamicsCrmEntityDataset).name, 'entityName');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: DynamicsCrmEntityDataset): Promise<DynamicsCrmEntityDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, DynamicsCrmEntityDataset.MODEL, 'entityName');
    }
}
